import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
const SectionHeader = ({ title, subtitle, onViewAll, children, pillarId, showViewAll,from }) => {
  const settings1 = {
  dots: true,
  arrows: true,
  speed: 500,
   slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  centerMode: false,
  //variableWidth: true,
responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
};
const navigate = useNavigate();
  console.log("TEST:-",title )
  return (
    <div className="mb-2rem section-block">
        <div class="continue-section">
          <div class="left">
            <h3 dangerouslySetInnerHTML={{
              __html: title,
            }}></h3>
            {subtitle && <p dangerouslySetInnerHTML={{
              __html: subtitle,
            }}></p>}
          </div>
            <div class="right">{onViewAll && showViewAll && (
          <button
            className="btns btn-linkd"
            tabIndex={0}
            aria-label="View more"
            onClick={() => {if(from==="global"){navigate("/explore?pillar_id=all");}else{onViewAll(pillarId)}}}
          >
            View more
          </button>
        )}</div>
        </div>
         <div className='row'>
        {React.Children.map(children, (child, index) => (
          pillarId === 'calc-id' ? 
          <>{ child }</>
          :
            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-3" key={index}>
              {child}
            </div>

        ))}
         </div>
      
   
    </div>
  );
};

export default SectionHeader;
